<template>
    <div style="background-color: #fff; min-height: 100vh;">
  <div v-if="name_logo !== 'gdf' && name_logo !== 'cec'&& name_logo !== 'fra'" :style="{}">
    <img :src="`/images/sfondo-${name_logo}.png`" style="width: 100%; height: auto; max-height: 570px;">
  </div>
  <nav :class="[`navbar`,
    generic_convenzioni_nav.includes(name_logo) ? 'nav_generic' : 'nav_fnp',
    isScrolled ? (generic_convenzioni_nav.includes(name_logo) ? 'bg-black-generic' : 'bg-black') : '']">
    <!-- Logo on the left for GDF and CEC -->
    <div class="logo left-logo" v-if="generic_convenzioni_nav.includes(name_logo)">
      <img class="img-gdf" src="/images/agf-logo.png" alt="Logo AGF" />
    </div>

    <!-- Logo on the right for GDF -->
    <div class="logo" v-if="name_logo === 'gdf'">
      <img src="/images/gdf-logo.png" alt="Logo GDF" class="right-logo-gdf"/>
    </div>

    <!-- Logo on the right for CEC -->
    <div class="logo" v-if="name_logo === 'cec'">
      <img src="/images/cec-logo.png" alt="Logo CEC" class="right-logo-cec"/>
    </div>

    <!-- Logo on the right for FNP -->
    <div class="logo" v-if="name_logo === 'fnp'">
      <img src="/images/fnp-logo.png" alt="Logo FNP" class="right-logo"/>
    </div>

    <!-- Logo on the right for FRAGASSI -->
    <div class="logo" v-if="name_logo === 'fra'">
      <img src="/images/fra-logo.png" alt="Logo FRA" class="right-logo-fra"/>
    </div>
    <!-- Logo on the right for KENDRO -->
    <div class="logo" v-if="name_logo === 'ken'">
      <img src="/images/ken-logo.jpg" alt="Logo KEN" class="right-logo-ken"/>
    </div>
  </nav>
  <div :class="{ 'main-content': generic_convenzioni_nav.includes(name_logo) }">
    <div v-if="testo_convenzione.includes(name_logo)">
    </div>
    <div class="offer-carousel">
      <!-- Header del carousel con titolo e navigazione -->
      <div class="carousel-header">
        <h2 class="carousel-title">Scegli la Tua Offerta</h2>
        <div class="carousel-tabs">
          <div v-for="(_, offerType, index) in types" :key="offerType"
            :class="['carousel-tab', { 'active-tab': currentTypeIndex === index }]" @click="setCurrentType(index)">
            {{ offerType }}
          </div>
        </div>
      </div>

      <!-- Contenuto del carousel -->
      <div class="carousel-content">
        <!-- Ciclo su tutti i tipi di offerta ma mostro solo quello corrente -->
        <div v-for="(els, type, index) in types" :key="type" class="offer-slide"
          :class="{ 'slide-active': currentTypeIndex === index }">
          <div class="flex offer-container">
            <!-- Le singole offerte (luce o gas) -->
            <div v-for="(el, type_pp) in els" :key="el.id" class="">
              <div class="right-div gradient-hover" :class="{ 'variabile-gradient': type === 'VARIABILE' }"
                @click="goToCaricamento(type_pp, type)">
                <div class="offer-type-badge">{{ type_pp == 'ee' ? 'Luce' : 'Gas' }}</div>
                <div class="content">
                  <h3 class="small-title">{{ el.name_offerta }}</h3>
                  <h2 class="large-price">
                    <span class="unit-label" v-if="type === 'VARIABILE'">{{ el.type_unit }} +</span> {{ type_pp == 'ee' ?
                      el[type === 'VARIABILE' ? 'f1' : 'm'].toFixed(3).replace('.', ',') :
                      el.m.toFixed(3).replace('.', ',') }}€/<span style="font-size: 0.7em;">{{ el.unit }}</span>
                  </h2>
                  <h2 class="small-title">{{ el.pcv }}€/Mese</h2>
                  <button class="offer-cta">
                    SOTTOSCRIVI {{ type_pp == 'ee' ? 'LUCE' : 'GAS' }}
                  </button>
                </div>
              </div>
            </div>
            <!-- Offerta combinata (luce + gas) -->
            <div class=" combined-card" v-if="Object.keys(els).length == 2">
              <div class="right-div gradient-hover" :class="{ 'variabile-gradient': type === 'VARIABILE' }"
                @click="goToCaricamento('ee&gas', type)">
                <div class="offer-type-badge">Luce & Gas</div>
                <div class="content">
                  <h3 class="small-title">{{ els.ee.name_offerta.replace(/LUCE|GAS/, '') }}</h3><div class="combined-offers">
                    <div class="offer-half">
                      <span class="unit-label">LUCE</span>
                      <h2 class="large-price smaller"><span v-if="type === 'VARIABILE'">{{ els.ee.type_unit }} +</span> {{ els.ee[type === 'VARIABILE' ? 'f1' : 'm'].toFixed(3).replace('.', ',')
                      }}€/<span style="font-size: 0.7em;">{{ els.ee.unit }}</span></h2>
                      <h2 class="small-title">{{ els.ee.pcv }}€/Mese</h2>
                    </div>
                    <div class="offer-half">
                      <span class="unit-label">GAS</span>
                      <h2 class="large-price smaller"><span v-if="type === 'VARIABILE'">{{ els.gas.type_unit }} +</span> {{ els.gas.m.toFixed(3).replace('.',
                        ',') }}€/<span style="font-size: 0.7em;">{{ els.gas.unit }}</span></h2>
                      <h2 class="small-title">{{ els.gas.pcv }}€/Mese</h2>
                    </div>
                  </div>
                  <button class="offer-cta">
                    SOTTOSCRIVI LUCE & GAS
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="[`flex w-full justify-content-center pt-5 offer-details offer-details_${name_logo}`]"
      id="offer-details">
    </div>

    <p v-if="name_logo === 'fnp'" class="font-normal text-xl leading-normal centered-paragraph text-align-center"
      style="color: #4c4c4c !important;">
      In sintesi, i vantaggi su alcuni parametri di riferimento: AGF Senza Pensieri Luce: prezzo variabile per TUTTE LE
      FASCE ORARIE a PUN + 0,0000€/Kwh e PCV con componente fissa a soli 6€ + IVA/mese AGF Senza Pensieri Gas: prezzo
      variabile con valore del parametro a pari a 0,000€/Smc e P Fix con componente fissa a soli 6€ + IVA/mese
    </p>
  </div>
  <div class="prezzo-variabile-container">
  <div class="prezzo-variabile-inner">
    <div class="prezzo-variabile-image">
      <img src="@/assets/img/vg.jpg" alt="Prezzo Variabile" />
    </div>
    <div class="prezzo-variabile-content">
      <h2 class="variabile-title">
        Come funziona il <span class="variabile-highlight">PREZZO VARIABILE?</span>
      </h2>
      <p class="variabile-subtitle">
        Il prezzo è variabile mensilmente e si basa sull'andamento del mercato:
      </p>
      <ul class="variabile-list">
        <li>PUN – Prezzo Unico Nazionale (Indice di Mercato Luce)</li>
        <li>PSV – Punto di Scambio Virtuale (Indice di Mercato Gas)</li>
        <li>PCV – Prezzo Commercializzazione Vendita</li>
        <li>CCV – 5€/Mese (Costo Commercializzazione Vendita)</li>
        <li>Spread (Ricarico rispetto agli Indici)</li>
      </ul>
    </div>
  </div>
</div>

  <div class="comprehension-container-fade-in"
    style="background-color: #ffffff; display: flex; flex-direction: column; align-items: center; padding:40px;">
    <h1 class="carousel-title" style="text-align: center; color: black; font-weight: 800; margin: 15px 0;">
      Comprensione della bolletta
    </h1>
    <div class="separator" style="background-color: #93c04a; height: 2px; width: 70%; margin: 15px auto;"></div>
    <div class="eligibility-content" style="display: flex; width: 100%; max-width: 1200px;">
      <div class="left-section" style="flex: 1; text-align: left; padding: 15px;">
        <p class="font-normal text-2xl leading-normal bolletta-testi">
          La parte evidenziata in <span style="color:green; font-weight: 700;">verde</span> è quella dove possiamo
          agire con l'applicazione della tariffa convenzionata.
        </p>
        <p class="font-normal bolletta-testi">
          La parte evidenziata in <span style="color:#a32323; font-weight: 700;">rosso</span> invece non è di
          competenza del gestore, pertanto quest'ultimo non può modificare tali voci. pertanto quest’ultimo non può
          modificare tali voci, che sono uguali per tutti i clienti, e vengono esclusi dal calcolo del prezzo proprio
          per
          questa ragione.
        </p>
      </div>
      <div class="right-section" style="padding: 15px;">
        <img src="@/assets/img/5-copia-1536x864.png" alt="Descrizione immagine" class="responsive-image" />
      </div>
    </div>
  </div>
  <div class="flex flex-wrap justify-content-center">
    <div v-for="(arr_tipologia,tipologia) in types" :key="tipologia" class="col-12 lg:col-6">
      <h1 :class="tipologia == 'FISSA' ? 'section-title-fixed' : 'section-title-variable'">
      OFFERTA PREZZO {{tipologia}}
    </h1>
      <div class="w-full" v-for="(el, type) in arr_tipologia" :key="type">
        <div class="eligibility-content" v-if="el">
          <div class="left-section" style="flex: 1; text-align: left;">
            <h2 :class="['comprehension-title', `bg-color-${type}`]" >{{type == 'ee' ? 'LUCE' : 'GAS'}} {{tipologia}}</h2>
            <p v-if="tipologia == 'VARIABILE'" class="font-normal text-2xl leading-normal bolletta-testi" style="color: #4c4c4c !important;">
              Il prezzo delle tariffe variabili, proposte dai fornitori, segue l'andamento del prezzo di mercato ({{ type == 'ee' ? 'PUN' : 'PSV' }}
              mensile) + <strong style="color:black; font-weight: 800;">spread, che nel nostro caso è {{ type == 'ee' ? el.f1.toFixed(3) : el.m.toFixed(3) }} €.
              </strong>
            </p>
            <p v-if="tipologia == 'FISSA'" class="font-normal text-2xl leading-normal bolletta-testi" style="color: #4c4c4c !important;">
              Il prezzo delle tariffe fisse, proposte dai fornitori, varia da {{ type == 'ee' ? '0,139€/Kwh a 0,179€/Kwh' : '0,32€/Smc a 2,50€/Smc' }} per una durata massima di 12 mesi.
            </p>
          </div>
          <div class="right-section" v-if="tipologia == 'VARIABILE'">
            <img v-if="type == 'ee'" src="@\assets\img\VAR_EE.png" alt="" class="responsive-image" />
            <img v-if="type == 'gas'" src="@\assets\img\VAR_GAS.png" alt="" class="responsive-image" />
          </div>
          <div class="right-section" v-if="tipologia == 'FISSA'">
            <img v-if="type == 'ee'" src="@\assets\img\FISSA_EE.png" alt="" class="responsive-image" />
            <img v-if="type == 'gas'" src="@\assets\img\FISSO_GAS.png" alt="" class="responsive-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="comprehension-container fade-in" style="display: flex; flex-direction: column; align-items: center;" v-if="convenzioni_esterne.includes(name_logo)">
    <h1 class="carousel-title" style="text-align: center; color:black; font-weight: 800;">Chi può aderire?
    </h1>
    <div class="separator"></div>
    <div class="eligibility-content">
      <div class="left-section" style="flex: 1; text-align: left; ">
        <ul class="details-list" v-if="name_logo === 'fnp'" style="padding-left: 20px; margin: 0;">
          <li style="line-height: 1.5;">Sottoscrivibile dai Soci FNP</li>
          <li style="line-height: 1.5;">Dai parenti e affini in linea retta di primo grado</li>
          <li style="line-height: 1.5;">Coniuge o convivente del socio</li>
        </ul>
        <p v-if="name_logo === 'fnp'" class="font-normal text-lg leading-normal" style="color: #4c4c4c !important;">
          Si ricorda che le offerte commerciali di cui sopra trovano applicazione con riferimento: all'attivazione di
          nuovi contratti con AGF (ad esclusione delle volture e delle volture con cambio fornitore)
        </p>
        <ul class="details-list" v-if="name_logo === 'cec'"
          style="padding-left: 20px; margin: 0; list-style-type: none;">
          <li style="line-height: 1.5;">L'offerta è sottoscrivibile, in via esclusiva, per i dipendenti C&C Consulting
            e relativi familiari.</li>
        </ul>
        <ul class="details-list" v-if="name_logo === 'gdf'" style="padding-left: 20px; margin: 0;">
          <p style="line-height: 1.5;">L'offerta è sottoscrivibile per il personale in servizio, in congedo ed in via
            del tutto esclusiva, per i vostri relativi familiari, per un massimo di 6 utenti cadauno.</p><br>
          <p style="line-height: 1.5;">Ciò significa che chi sottoscrive l'offerta può utilizzare il suo codice
            fiscale come codice referente per un massimo di altre 6 componenti del proprio nucleo familiare.</p>
        </ul>
      </div>
      <div class="right-section" style="flex: 1; text-align: left;">
        <img src="@/assets/img/soggetto.png" alt="Eligibility Image" class="responsive-image-bolletta-eligibility" />
      </div>
    </div>
  </div>

  <!-- NUOVA COMPONENTE DURATA -->
  <div v-if="durata_offerta.includes(name_logo)">
    <div class="durata_offerta" style="display: flex; flex-direction: column; align-items: center;">
      <h1 class="comprehension-title durata_offerta" style="text-align: center; color:black; font-weight: 800;">
        DURATA
        DELL'OFFERTA
      </h1>
      <div class="separator"></div>
      <div class="eligibility-content">
        <p class="font-normal text-2xl leading-normal bolletta-testi" style="color: #4c4c4c !important;">
          La presente proposta commerciale ha validità di 1
          anno a partire dal <strong style="color: black;">01/12/2024</strong>
        </p>
      </div>
    </div>
  </div>
  <div class="chart-container">
    <div class="chart-header">
      <h2 class="carousel-title">POINT AGF</h2> <!-- Title for the map section -->
    </div>
    <div id="map-container" style="height: 400px;"></div>
    <div class="legend" style="margin-top: 20px; display: flex; align-items: center;">
      <div style="display: flex; align-items: center; margin-right: 20px;">
        <div class="dot" style="background-color:#9fc75f;"></div>
        <span style="margin-left: 5px; font-weight: bold;">AGF Point</span>
      </div>

      <div style="display: flex; align-items: center; margin-right: 20px;">
        <div class="dot" style="background-color: #2cc9d1;"></div>
        <span style="margin-left: 5px; font-weight: bold;">AGF Corner</span>
      </div>

      <div style="display: flex; align-items: center;">
        <div class="dot" style="background-color: #B6A555;"></div>
        <span style="margin-left: 5px; font-weight: bold;">AGF Partner</span>
      </div>
    </div>
  </div>
  <footer :class="[`footer_${name_logo}`]">
    <div class="container">
      <div class="footer-cta pt-5 pb-5">
        <div class="row justify-content-center">
          <div class="col-xl-4 col-md-4 mb-30" style="margin-right: 40px;">
            <div class="single-cta text-center">
              <div class="cta-text text-center">
                <h4><i class="pi pi-map-marker"></i> Sede Legale e Operativa</h4>
                <span style="font-size: 15px;">AGF Energy SpA / Piva 08150620725</span><br>
                <span style="font-size: 15px;">BARI Str. San Pasquale 7-9/E – 70125</span>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 mb-30" style="margin-right: 40px;">
            <div class="single-cta text-center">
              <div class="cta-text text-center">
                <h4><i class="pi pi-map-marker"></i> Sedi Operative</h4>
                <span style="font-size: 15px;">MILANO Via Valparaiso, 10 – 20144</span><br>
                <span style="font-size: 15px;">ROMA Via Giulio Vincenzo Bona, 87 – 00157</span>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 mb-30" style="margin-right: 40px;">
            <div class="single-cta text-center">
              <div class="cta-text text-center">
                <h4>Social Media</h4>
                <ul class="social-media-list">
                  <li>
                    <a href="https://www.instagram.com/agfenergy/" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="feather feather-instagram">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" href="https://www.instagram.com/agfenergy/" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/agf-energy" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="feather feather-linkedin">
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                        <rect x="2" y="9" width="4" height="12" />
                        <circle cx="4" cy="4" r="2" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/AGFEnergysrl/">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="feather feather-facebook">
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-logo text-center mt-4">
          <a href="index.html">
            <img src="https://agfenergy.it/wp-content/uploads/2023/06/marchiologo.png" class="img-fluid" alt="logo"
              style="width: 60%; margin-top:30px">
          </a>
        </div>
      </div>
    </div>
  </footer>
</div>
</template>
<script>
// @ is an alias to /src
// eslint-disable-next-line no-unused-vars

import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Service from '@/services/ask-pratiche/pratiche-wizard'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  setup(props, { emit }) {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const isScrolled = ref(false);
    const route = useRoute()

    const types = ref()
    const token = route.params.token
    const router = useRouter();
    const name_logo = ref('')
    const vantaggifnp = ref(['fnp'])
    const durata_offerta = ref(['fnp'])
    const testo_convenzione = ref(['fnp'])
    const map = ref(null);
    const locations = ref([]);
    const navs = ref(['fnp', 'gdf', 'fra', 'ken'])
    const generic_convenzioni_nav = ref(['gdf','cec','por', 'fra', 'ken'])
    const convenzioni_esterne = ref(['gdf','cec','fnp', 'fra', 'ken'])

    // Nuove variabili per il carousel
    const currentTypeIndex = ref(0);

    const handleIntersection = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        } else {
          entry.target.classList.remove('active');
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1
    })

    const goToCaricamento = (type, tipo) => {
      router.push(`/caricamento-contratto/${token}/${tipo}/${type}`)
    }

    // Funzione per cambiare il tipo di offerta visualizzato
    const setCurrentType = (index) => {
      currentTypeIndex.value = index;
    }

    const setTypesOfferta = async (items) => {
      let offerte_fix = items.filter(item => item.type_offerta == 1)
      let offerte_index = items.filter(item => item.type_offerta == 2)
      let obj = {}
      if (offerte_fix.length == 2) {
        obj.FISSA = {
          ee: null,
          gas: null
        }
      }
      if (offerte_index.length == 2) {
        obj.VARIABILE = {
          ee: null,
          gas: null
        }
      }
      let tipologie = [
        { value: 1, name: 'FISSA', label: 'fix' },
        { value: 2, name: 'VARIABILE', label: 'index' }
      ]
      items.forEach(item => {
        let index_tipologia = tipologie.findIndex(tipologia => tipologia.value == item.type_offerta)
        let tipo = tipologie[index_tipologia]

        item.description = item.type == 'ee' ? 'LUCE' : 'GAS'
        item.unit = item.type == 'ee' ? 'Kwh' : 'Smc'
        item.type_unit = item.type == 'ee' ? 'PUN' : 'PSV'
        obj[tipo.name][item.type] = item
      })
      types.value = obj
    }

    const getDetailPoints = async () => {
      await service.getDetailPoints()
        .then((res) => {
          Object.keys(res.items).forEach(key => {
            res.items[key].lat = Number(res.items[key].lat)
            res.items[key].lng = Number(res.items[key].lng)
          })
          locations.value = res.items
        })
    }

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 50; // Change threshold as needed
    }

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    const initMap = async () => {
      await getDetailPoints()
        .then((res) => {
          map.value = L.map('map-container').setView([41.9028, 12.4964], 6); // Set initial map view

          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
          }).addTo(map.value);

          // Create a bounds group from all location markers
          const markers = locations.value.map(location => {
            let color
            if (location.is_point_diretto) {
              color = 'green'
            } else if (location.is_point) {
              color = 'blue'
            } else {
              color = 'senape'
            }
            const customIcon = L.icon({
              iconUrl: `/images/marker-icon-agf-${color}_72.png`,
              iconSize: [25, 41],
              iconAnchor: [50, 41],
              popupAnchor: [1, -34],
              shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
              shadowSize: [41, 41]
            });
            const popupContent = `
              <div style="text-align: center;">
                <strong>${location.name}</strong><br>
                <span style="font-size: smaller;">${location.address || ''}</span>
              </div>
            `;
            return L.marker([location.lat, location.lng], { icon: customIcon })
              .addTo(map.value)
              .bindPopup(popupContent);
          });

          const group = L.featureGroup(markers);
          map.value.fitBounds(group.getBounds(), { padding: [80, 80] });
        })
    };

    onMounted(() => {
      Promise.all([
        setTypesOfferta(route.meta),
        initMap()
      ])
      window.addEventListener('scroll', handleScroll);
      const targets = document.querySelectorAll('.fade-in');
      targets.forEach(target => observer.observe(target));
      name_logo.value = route.meta[0].name_logo;
    });

    return {
      isScrolled,
      types,
      token,
      goToCaricamento,
      name_logo,
      durata_offerta,
      vantaggifnp,
      testo_convenzione,
      map,
      locations,
      navs,
      currentTypeIndex,
      setCurrentType,
      generic_convenzioni_nav,
      convenzioni_esterne
    };
  }
}
</script>

<style scoped>
/* -----------------------
   IMPORTAZIONI FONT  
----------------------- */
@import url('https://fonts.googleapis.com/css2?family=Host+Grotesk:ital,wght@0,300..800;1,300..800&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Host+Grotesk:ital,wght@0,300..800;1,300..800&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');

/* -----------------------
   RESET E BASI
----------------------- */
body {
  margin: 0;
  font-family: 'Host Grotesk', sans-serif;
  background-color: #000;
}
#app, [data-v-app], [data-v-app=true] {
  background-color: #fff !important;
}
/* -----------------------
   LAYOUT PRINCIPALE
----------------------- */
.flex-container {
  display: flex;
  height: 50vh;
}

.main-content {
  padding-top: 150px;
}

/* -----------------------
   NAVBAR
----------------------- */
.nav_fnp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 10px 20px;
  background-color: transparent !important;
}

.nav_gdf,
.nav_generic {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #434343 !important;
  height: 150px;
}

.bg-black {
  background-color: #217b01d4 !important;
}

.bg-black-generic,
.bg-black-cec {
  background-color: #707070 !important;
}

.left-logo img {
  width: 20% !important;
  margin-top: 20px;
  margin-left: 0;
}

.right-logo img {
  width: 39% !important;
  margin-top: 20px;
  margin-left: 60%;
}

/* -----------------------
   OFFERTE CONTAINER E SEZIONI
----------------------- */
.flex.flex-wrap.justify-content-center {
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  gap: 40px;
}

.col-12.lg\:col-6 {
  width: 100%;
  margin-bottom: 40px;
  position: relative;
}
.section-title-fixed,
.section-title-variable {
  display: block;
  font-size: 2.4rem;
  font-weight: 800;
  margin-bottom: 30px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-family: 'Host Grotesk', sans-serif;
  padding-bottom: 15px;
  position: relative;
}

.section-title-fixed {
  color: #75bf15;
}

.section-title-variable {
  color: #004aad;
}

.section-title-fixed::after,
.section-title-variable::after {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 5px;
  border-radius: 4px;
}

.section-title-fixed::after {
  background: linear-gradient(90deg, #5da010, #75bf15);
}

.section-title-variable::after {
  background: linear-gradient(90deg, #0a3d8a, #004aad);
}


/* Card delle offerte */
.eligibility-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  border-radius: 20px;
  padding: 10px;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
  overflow: hidden;
}

.col-12.lg\:col-6:first-child .eligibility-content {
  background-color: rgba(117, 191, 21, 0.05);
  border-left: 4px solid #75bf15;
}

.col-12.lg\:col-6:last-child .eligibility-content {
  background-color: rgba(0, 74, 173, 0.05);
  border-left: 4px solid #004aad;
}

.eligibility-content:hover {
  transform: translateY(-8px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.12);
}

.left-section {
  flex: 1;
  padding: 25px;
  text-align: left;
}

.right-section {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 40%;
  padding: 20px;
}

.comprehension-title {
  display: inline-block;
  font-size: 1.7rem;
  color: #ffffff;
  margin-bottom: 25px;
  padding: 15px 25px;
  border-radius: 50px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 700;
  font-family: 'Host Grotesk', sans-serif;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.col-12.lg\:col-6:first-child .bg-color-ee,
.col-12.lg\:col-6:first-child .bg-color-gas {
  background: linear-gradient(135deg, #75bf15, #5da010);
}

.col-12.lg\:col-6:last-child .bg-color-ee,
.col-12.lg\:col-6:last-child .bg-color-gas {
  background: linear-gradient(135deg, #004aad, #0a3d8a);
}

.comprehension-title::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(-100%) skewX(-15deg);
  transition: transform 0.6s ease;
}

.eligibility-content:hover .comprehension-title::before {
  transform: translateX(100%) skewX(-15deg);
}

.bg-color-ee {
  background: linear-gradient(135deg, #75bf15, #5da010);
}

.bg-color-gas {
  background: linear-gradient(135deg, #004aad, #0a3d8a);
}

/* Testo descrittivo */
.bolletta-testi {
  font-size: 1.6rem !important;
  color: #4c4c4c !important;
  font-weight: 700;
  line-height: 1.7;
  margin-top: 20px;
  transition: color 0.3s ease;
}

.eligibility-content:hover .bolletta-testi {
  color: #333333 !important;
}

/* Evidenziazione dello spread con colori diversi */
.col-12.lg\:col-6:first-child .bolletta-testi strong::after {
  background-color: rgba(117, 191, 21, 0.3);
}

.col-12.lg\:col-6:last-child .bolletta-testi strong::after {
  background-color: rgba(0, 74, 173, 0.3);
}

.bolletta-testi strong {
  position: relative;
  display: inline-block;
  padding: 0 5px;
  color: black;
  font-weight: 800;
  z-index: 1;
}

.bolletta-testi strong::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6px;
  z-index: -1;
}

/* Immagini responsive */
.responsive-image {
  max-width: 100%;
  height: auto;
  transition: transform 0.5s ease;
  filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.15));
}

.eligibility-content:hover .responsive-image {
  transform: scale(1.05) translateY(-5px);
}

.responsive-image-bolletta,
.responsive-image-bolletta-eligibility {
  width: 70%;
  max-width: 100%;
}

/* -----------------------
   PREZZO VARIABILE CONTAINER
----------------------- */
.prezzo-variabile-container {
  max-width: 100%;
  margin: 60px auto;
  display: flex;
  justify-content: center;
  padding: 40px;
  background-color: white;
}

.prezzo-variabile-inner {
  display: flex;
  align-items: center;
  max-width: 1200px;
  width: 100%;
}

.prezzo-variabile-image {
  flex: 0 0 auto;
  margin-right: 40px;
  width: 42%;
  max-width: 500px;
}

.prezzo-variabile-image img {
  width: 100%;
  height: auto;
  display: block;
}

.prezzo-variabile-content {
  flex: 1;
}

.variabile-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #000;
  font-family: 'Host Grotesk', sans-serif;
  line-height: 1.2;
}

.variabile-highlight {
  color: #0081ed;
  font-weight: 800;
  display: inline-block;
  position: relative;
  padding-bottom: 5px;
}

.variabile-highlight::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #0081ed;
  transform-origin: right;
  transform: scaleX(1);
  transition: transform 0.3s ease, height 0.3s ease, background-color 0.3s ease;
}

.variabile-highlight:hover::after {
  transform-origin: left;
  transform: scaleX(1.05);
  height: 4px;
  background-color: #0081ed;
}

.variabile-subtitle {
  font-size: 1.6rem;
  color: #000;
  margin-bottom: 15px;
  font-weight: 700;
  font-family: 'Host Grotesk', sans-serif;
}

.variabile-list {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
  color: #000;
}

.variabile-list li {
  margin-bottom: 8px;
  font-size: 1.5rem;
  line-height: 1.4;
  font-family: 'Host Grotesk', sans-serif;
}

/* -----------------------
   STILI OFFERTA
----------------------- */
.offerta-variabile {
  display: flex;
  align-items: center;
  margin-top: 80px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.offerta-variabile-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.nostra-offerta_fnp {
  background-color: white;
  padding: 20px;
}

.offer-title {
  font-size: 3rem;
  color: rgb(0, 0, 0);
  font-family: 'Host Grotesk', sans-serif;
  margin-bottom: 10px;
}

.variabile {
  display: inline;
  font-size: 2.5rem;
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  margin: 20px auto;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.variabile:hover {
  transform: scale(1.05);
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.4);
}

.fissa,
.variabile {
  display: inline-block;
  padding: 10px 30px;
  background-color: #f1f1f1;
  border-radius: 25px;
  margin: 0 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Host Grotesk', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
}

.fissa.active,
.variabile.active {
  background-color: #75bf15;
  color: white;
}

.variabile.active {
  background-color: #2e67a9 !important;
  color: white;
}

/* -----------------------
   STILI CARD E CONTENITORI
----------------------- */
.title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 20px;
}

.left-title-penseri,
.right-title-pensieri {
  font-size: 2rem;
  color: #0f0d0d;
  margin: 0;
}

.title-container h1 {
  margin-top: 10px;
}

.center-title {
  text-align: center;
  font-size: 2rem;
  color: white;
  background: #006344;
  padding: 10px;
  margin: 20px auto;
  border-radius: 8px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
  width: 60%;
  max-width: 800px;
}

.large-price-prezzo {
  display: inline-block;
  font-size: 2.25rem;
  color: white;
  padding: 0.5rem;
  border-radius: 8px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
  margin: 20px 0 10px 80px;
  text-align: left !important;
  background: #93c04a;
}

.rounded-container {
  display: flex;
  height: 70vh;
  padding: 50px 80px;
  gap: 20px;
}

.gradient-hover {
  background: linear-gradient(49deg, #478509, #54a360);
  transition: background 0.3s ease;
  border-radius: 8px;
  flex: 1;
  padding: 20px;
}

.gradient-hover:hover {
  background: linear-gradient(135deg, #2e421a, #99da93);
}

.variabile-gradient {
  background: linear-gradient(135deg, #2e67a9, #4389c7) !important;
}

.variabile-gradient:hover {
  background: linear-gradient(135deg, #1e4a7a, #3372a8);
}

.left-div,
.right-div {
  flex: 1;
  background-color: #000;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin: -11px 3px;
}

.right-div {
  height: 100%;
  min-height: 420px;
  border-radius: 20px;
  padding: 35px 25px;
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 0;
}

.right-div::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.2), transparent 70%);
  opacity: 0.4;
  transition: opacity 0.4s ease;
}

.right-div:hover::before {
  opacity: 0.6;
}

.content {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  position: relative;
  z-index: 2;
  padding: 10px 0;
}

.text-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #000000;
  color: white;
  font-family: "Raleway", sans-serif;
}

.small-title {
  font-size: 1.75rem;
  font-family: 'Host Grotesk', sans-serif;
}

.large-price {
  font-size: 3.75rem;
  font-family: 'Host Grotesk', sans-serif;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 5px;
  flex-wrap: wrap;
}

.large-price.smaller {
  font-size: 2.2rem;
  margin: 10px 0;
}

.custom-background {
  font-size: 3rem;
  color: #212121;
  margin-bottom: 25px;
  font-family: 'Host Grotesk', sans-serif;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.test {
  font-family: 'Host Grotesk', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 15px;
  text-align: center;
}

/* -----------------------
   COMPRENSIONE E INFOGRAFICHE
----------------------- */
.comprehension-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  background-color: #ffffff;
}
.comprehension-container.fade-in {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 20px;
  background-color: #ffffff;
  margin: 30px auto;
  max-width: 1200px;
  border-radius: 15px;
}

.durata_offerta {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
  background-color: #ffffff;
}

.comprehension-content {
  display: flex;
  width: 100%;
  margin-top: 50px;
  margin-left: 50px;
}

.comprehension-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 10px;
}

.centered-paragraph {
  color: #4c4c4c !important;
  font-weight: 700;
  text-align: center;
}

.details-list {
  list-style-type: disc;
  padding-left: 20px;
  color: #4c4c4c;
  text-align: left;
  font-size: 1.5rem;
  margin: 0;
  font-family: 'Host Grotesk', sans-serif;
}

.title-wrapper {
  margin-bottom: 20px;
}

.price-title {
  font-size: 3rem;
  text-align: left !important;
  color: #212121;
  margin-bottom: 25px;
  font-family: 'Host Grotesk', sans-serif;
  font-weight: 800;
}

.prezzo .content {
  text-align: left !important;
}

.price-container {
  display: flex;
  justify-content: space-between;
  padding: 40px 20px;
  background-color: #ffffff;
  align-items: flex-start;
}

.price-highlight {
  color: #75bf15;
  font-weight: 800;
  display: inline-block;
  margin-bottom: 15px;
  position: relative;
  padding-bottom: 5px;
}

.price-highlight::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #75bf15;
  transform-origin: right;
  transform: scaleX(1);
  transition: transform 0.3s ease;
}

.price-highlight:hover::after {
  transform-origin: left;
  transform: scaleX(1.05);
  height: 4px;
  background-color: #93c04a;
}

.prezzo {
  flex: 1;
  border-radius: 15px;
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: #ffffff;
  margin: 0 10px;
}

.font-normal {
  font-size: 1rem;
  text-align: left;
}

/* -----------------------
   OFFERTA CAROUSEL
----------------------- */
.offer-carousel {
  margin: 0 auto 40px;
  background: linear-gradient(to bottom, #ffffff, #f7f9fc);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 35px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.carousel-header {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
}

.carousel-header::after {
  content: '';
  display: block;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #478509, #93c04a);
  margin: 15px auto 0;
  border-radius: 2px;
}

.carousel-title {
  font-size: 3rem;
  color: #212121;
  margin-bottom: 25px;
  font-family: 'Host Grotesk', sans-serif;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.carousel-tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 35px;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 40px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.carousel-tab {
  padding: 14px 35px;
  background-color: transparent;
  color: #555;
  border-radius: 30px;
  font-family: 'Host Grotesk', sans-serif;
  font-weight: 600;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  z-index: 1;
}

.carousel-tab:hover {
  color: #333;
  transform: translateY(-2px);
}

.active-tab {
  background: linear-gradient(135deg, #478509, #54a360);
  color: white !important;
  box-shadow: 0 8px 20px rgba(71, 133, 9, 0.25);
}

.carousel-tab::before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(135deg, #478509, #54a360);
  border-radius: 30px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.carousel-tab:hover::before {
  opacity: 0.1;
}
.carousel-tabs .carousel-tab.active-tab,
.carousel-tab[data-type="VARIABILE"].active-tab,
.active-tab:contains("VARIABILE") {
  background: #3069ab !important; 
  color: white !important;
  box-shadow: 0 8px 20px rgba(48, 105, 171, 0.25) !important; 
}

.carousel-tab:nth-child(2).active-tab {
  background: #3069ab !important;
  color: white !important;
}

.carousel-tab:hover {
  color: #333;
  transform: translateY(-2px);
}

.carousel-tab:nth-child(2):hover::before {
  background: #3069ab !important;
  opacity: 0.1;
}

.carousel-title + .separator,
.chart-header .separator,
hr.blue-separator {
  background: #707070 !important;
}

.carousel-tab.active-tab,
.active-tab {
  color: white !important;
}
.carousel-content {
  position: relative;
  overflow: visible;
  min-height: 480px;
  padding-top: 20px;
}

.offer-slide {
  opacity: 0;
  transform: translateX(40px) scale(0.98);
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: absolute;
  width: 100%;
  pointer-events: none;
  padding-top: 10px;
}

.slide-active {
  opacity: 1;
  transform: translateX(0) scale(1);
  position: relative;
  pointer-events: all;
}

.offer-container {
  display: flex;
  gap: 25px;
  justify-content: center;
  align-items: stretch;
  margin-top: 20px;
  perspective: 1000px;
}

/* -----------------------
   COMPONENTI OFFERTA
----------------------- */
.offerte {
  max-width: 100%;
  height: 620px;
  display: block;
}

.offer-type-badge {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  backdrop-filter: blur(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.unit-label {
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  margin: 0;
  font-size: inherit;
  font-weight: normal;
  display: inline;
  vertical-align: baseline;
}

.combined-offers {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin: 15px 0;
  position: relative;
}

.combined-offers::after {
  content: '+';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
}

.offer-half {
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 15px;
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;
}

.offer-half:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-5px);
}

.offer-item {
  text-align: center;
  margin-bottom: 15px;
}

.offer-details_fnp {
  background-color: #ffffff;
}

.convenzioni_fnp {
  display: none;
}

/* -----------------------
   BOTTONI
----------------------- */
button.offer-cta {
  background-color: #cd132b;
  color: white;
  border: none;
  padding: 16px 25px;
  font-size: 1.1rem;
  border-radius: 15px;
  margin-top: 20px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  font-family: 'Host Grotesk', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  width: 100%;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 15px rgba(205, 19, 43, 0.3);
}

button.offer-cta::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

button.offer-cta:hover {
  background-color: #e92e46;
  transform: scale(1.03);
  box-shadow: 0 12px 20px rgba(205, 19, 43, 0.4);
}

button.offer-cta:hover::after {
  transform: translateX(100%);
}

.custom-button {
  margin-top: 10px;
  margin-top: 10px;
  font-size: 1rem;
  padding: 15px 40px;
  transition: background-color 0.3s ease, transform 0.3s ease;
  background-color: #eeff00;
  color: black;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.custom-button:hover {
  background-color: #c5e700;
  transform: scale(1.1);
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  padding: 20px;
  text-align: center;
}

/* -----------------------
   UTILITIES
----------------------- */
.separator {
  background-color: #93c04a;
  height: 2px;
  width: 70%;
  margin: 20px auto;
}

.title {
  margin-bottom: 30px;
  text-align: center;
}

.fade-in {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s ease-out, transform 0.5s ease-out;
}

.fade-in.active {
  opacity: 1;
  transform: translateY(0);
}

.logo {
  flex: 1;
  text-align: center;
}

.logo-image-offerta {
  display: block;
  margin: 0 auto;
  width: 10%;
  height: auto;
  margin-top: 30px;
}

/* -----------------------
   COLORI DI SFONDO
----------------------- */
.bg-color-ee {
  background-color: #75bf15;
}

.bg-color-gas {
  background-color: #004aad;
}

/* -----------------------
   MAPPA
----------------------- */
.legend {
  font-size: 14px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 40px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
  margin: 30px 0;
}

.chart-header {
  margin-bottom: 20px;
}

.chart-title {
  font-size: 2rem;
  color: #000;
  font-weight: bold;
  font-family: 'Host Grotesk', sans-serif;
  text-align: center;
}

#map-container {
  height: 570px !important;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

/* -----------------------
   FOOTER
----------------------- */
.footer_gdf,
.footer_cec {
  background-color: #434343 !important;
  color: #fff;
}

.footer_fnp {
  background-color: #45912c !important;
  color: #fff;
}

.footer-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.single-cta {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 15px;
  transition: transform 0.3s ease;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 20px;
}

.single-cta i {
  font-size: 25px;
  margin-right: 10px;
  color: #93c04a;
  transition: color 0.3s ease;
}

.social-media-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}

.social-media-list li {
  margin: 0 10px;
}

.single-cta:hover i {
  color: #ffffff;
  transform: translateY(-5px);
}

.right-logo-gdf,
.right-logo-cec {
  width: 20% !important;
}

.right-logo-fra{
  width: 100px !important;
}

.right-logo-ken{
  width: 100px !important;
}



/* -----------------------
   MEDIA QUERIES
----------------------- */

@media (max-width: 992px) {
  .col-12.lg\:col-6::before {
    font-size: 1.8rem;
    margin-top: 30px;
  }
  
  .col-12.lg\:col-6::after {
    top: 40px;
  }
  
  .comprehension-title {
    font-size: 1.3rem;
    padding: 10px 15px;
  }
  
  .bolletta-testi {
    font-size: 1.2rem !important;
  }

  .flex.flex-wrap.justify-content-center {
    flex-wrap: wrap;
  }
  
  .col-12.lg\:col-6 {
    flex: 100%;
    max-width: 100%;
  }
  
  .prezzo-variabile-image {
    width: 35%;
    margin-right: 30px;
  }
}

@media (max-width: 768px) {
  body {
    overflow-x: hidden;
  }

  .navbar {
    display: flex;
    align-items: center;
  }

  .nav_gdf,
  .nav_generic {
    background-color: #434343 !important;
    height: 80px;
  }

  .left-logo img {
    width: 60% !important;
  }

  .main-content {
    padding-top: 30px;
  }

  .title {
    display: none;
  }

  .logo_fnp {
    display: none;
  }

  .logo_gdf {
    display: block;
  }

  .logo-image-offerta {
    display: block;
    margin: 0 auto;
    width: 60%;
    height: auto;
    margin-top: 30px;
  }

  .center-title {
    width: 88%;
    font-size: 1.5rem;
  }
  
  .col-12.lg\:col-6::before {
    font-size: 1.5rem;
    padding: 15px 10px;
    margin-bottom: 25px;
    background: linear-gradient(90deg, #212121, #505050);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: 100%;
  }
  
  .col-12.lg\:col-6::after {
    top: 45px;
    width: 60px;
    height: 3px;
  }
  
  .col-12.lg\:col-6:nth-child(2)::before {
    margin-top: 40px;
  }

  .eligibility-content {
    flex-direction: column;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .left-section {
    flex: 1;
    padding: 15px;
    max-width: 100% !important;
    width: 100%;
    box-sizing: border-box;
  }
  
  .right-section {
    flex: 1;
    padding: 10px;
    max-width: 100% !important;
    width: 100%;
    margin-top: 0;
    box-sizing: border-box;
  }

  .comprehension-title {
    font-size: 1.8rem;
    margin-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
    display: block;
    text-align: center;
  }
  
  .bolletta-testi {
    font-size: 1.25rem !important;
    color: #4c4c4c !important;
    margin: 15px 5px;
    padding: 0;
    width: 100%;
    box-sizing: border-box;
    line-height: 1.5;
    font-weight: 700;
  }
  
  .bolletta-testi strong {
    color: black !important;
    font-weight: 800 !important;
    display: inline;
  }
  
  .centered-paragraph {
    font-size: 1rem !important;
    color: #9f9f9f;
    margin: 10px 0;
    padding: 0 10px;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  
  .small-title {
    font-size: 1.2rem !important;
    text-align: center;
    margin: 5px 0;
    width: 100%;
  }
  
  .price-title {
    font-size: 1.8rem;
    margin-bottom: 15px;
  }
  
  .price-container {
    flex-direction: column;
    padding: 20px;
  }
  
  .image-container {
    margin-bottom: 30px;
  }
  
  .responsive-image {
    width: 100% !important;
    max-height: 250px;
    object-fit: contain;
    height: auto !important;
    max-width: 100% !important;
  }

  .responsive-image-bolletta-eligibility {
    width: 100%;
    max-width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
  
  .image-container {
    flex: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
  }

  .image-container img {
    max-width: 70%;
    height: auto;
  }
  
  .offerte {
    margin-top: 12%;
    margin-bottom: 12%;
    width: 60%;
  }

  .offer-title {
    font-size: 3rem !important;
    margin-bottom: 85px;
  }
  
  .rounded-container {
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 20px;
  }
  
  .price-container {
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  
  .comprehension-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    width: 100%;
  }

  .comprehension-container-bolletta {
    margin-bottom: 60px;
  }
  .col-12.lg\:col-6[data-v-616bc3dc]:first-child::after {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 5px;
    background: linear-gradient(90deg, #5da010, #75bf15);
    border-radius: 4px;
}
  .comprehension-content {
    max-width: 100% !important;
    margin: 20px auto !important;
    padding: 10px !important;
    margin-top: 20px !important;
    display: flex;
    flex-direction: column !important;
    align-items: center;
    width: 100%;
    margin-left: 0 !important;
  }
  
  .comprehension-text {
    font-size: 1.8rem;
    margin-bottom: 10px;
    text-align: left;
    width: 100%;
  }
  
  .content {
    text-align: center;
    padding: 5px 0;
    width: 100%;
  }
  
  .separator {
    width: 97%;
    margin: 10px auto;
  }

  .left-div,
  .right-div {
    width: 100%;
    margin-bottom: 10px;
    text-align: center;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.1);
    box-sizing: border-box;
  }
  
  .right-div {
    min-height: auto;
    padding: 25px 20px;
    margin: 0;
    border-radius: 15px;
  }
  
  .right-div,
  .right-div h2,
  .right-div h3,
  .right-div span,
  .right-div button {
    color: white !important;
  }
  
  .prezzo {
    flex: none;
    padding: 0;
    text-align: center;
    width: 100%;
  }

  .large-price {
    font-size: 1.5rem;
    color: white;
    padding: 0.5rem;
    border-radius: 8px;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
    margin: 10px 0;
    text-align: center;
    justify-content: center;
    box-shadow: none !important;
    padding: 0 !important;
    width: 100%;
  }
  
  .large-price.smaller {
    font-size: 1.5rem;
    justify-content: center;
    box-shadow: none !important;
    padding: 0 !important;
  }
  
  .custom-background {
    width: 100%;
    font-size: 2rem;
    padding: 0.5rem;
    margin-top: 20px;
    box-sizing: border-box;
  }
  
  .unit-label {
    display: inline !important;
    background-color: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
    font-size: inherit !important;
  }
  
  .offer-type-badge {
    top: 10px;
    right: 10px;
    font-size: 0.7rem;
    padding: 5px 10px;
  }
  
  /* Font e testi */
  .font-normal {
    font-size: 1rem;
    text-align: left;
    width: 100%;
  }
  
  .variabile-title {
    text-align: center;
    font-size: 2.2em;
  }

  .variabile-subtitle {
  font-size: 1.2em
  }
  .variabile-list {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
  color: #000;
}

.variabile-list li {
  margin-bottom: 8px;
  font-size: 1.1rem;
  line-height: 1.4;
  font-family: 'Host Grotesk', sans-serif;
}
  .details-list {
    padding-left: 0;
    list-style-position: inside;
    margin: 0;
    font-size: 1rem;
    width: 100%;
  }
  
  .prezzo-variabile-inner {
    flex-direction: column;
  }
  
  .prezzo-variabile-image {
    width: 80%; 
    margin: 0 auto 30px;
  }
  
  .details-list li {
    text-align: left;
    line-height: 1.5;
    margin: 5px 0;
  }

  /* Offerte variabili e fisse */
  .fissa,
  .variabile {
    color: #ffffff !important;
  }

  .fissa.active {
    background-color: #75bf15 !important;
    color: white !important;
  }

  .variabile.active {
    background-color: #2e67a9 !important;
    color: white !important;
  }
  .variabile-subtitle {
  font-size: 1.2em
  }
  .gradient-hover {
    background: linear-gradient(135deg, #478509, #54a360) !important;
  }

  .variabile-gradient {
    background: linear-gradient(135deg, #2e67a9, #4389c7) !important;
  }

  /* Carousel e slides */
  .carousel-content {
    padding: 0 10px;
    width: 100%;
  }

  .carousel-title {
    margin-top: 60px;
    color: #212121;
    font-size: 2.2rem;
  }

  .offer-container {
    flex-direction: column;
    width: 100%;
    gap: 15px;
  }
  
  /* Offerte combinate */
  .combined-card {
    width: 100%;
  }

  .combined-offers {
    flex-direction: column;
    gap: 15px;
    position: relative;
    padding: 15px 0;
    width: 100%;
  }

  .combined-offers::after {
    display: none;
  }

  .combined-offers .offer-half:first-child::after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 70%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.3);
    margin-top: 10px;
  }
  
  .offer-half {
    padding: 10px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.15) !important;
    box-sizing: border-box;
  }

  /* Bottoni */
  button.offer-cta {
    padding: 12px 20px;
    font-size: 0.9rem;
    margin-top: 15px;
    width: 100%;
    box-sizing: border-box;
  }

  .offer-cta {
    width: 100%;
    padding: 12px 15px;
    font-size: 0.9rem;
    margin-top: 15px;
    box-sizing: border-box;
  }
  
  /* Layout offerte */
  .offer-details {
    display: flex;
    flex-direction: column !important;
    width: 100%;
    padding: 0 10px;
    border-radius: 10px;
    box-sizing: border-box;
  }

  /* Footer su mobile */
  .footer-section {
    background-color: #232323;
    color: #fff;
    padding: 20px 0;
    text-align: center;
    width: 100%;
  }

  .footer-cta {
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
    width: 100%;
  }

  .row {
    flex-direction: column;
    align-items: center;
    margin: 0;
    width: 100%;
  }

  .col-xl-4,
  .col-md-4 {
    width: 100%;
    margin-bottom: 20px;
    margin-right: 0;
  }

  .single-cta {
    margin: 0 10px;
  }

  .cta-text h4 {
    font-size: 1rem;
    margin-bottom: 5px;
  }

  .cta-text span,
  .cta-text ul {
    font-size: 0.875rem;
  }

  .social-media-list {
    list-style-type: none;
    padding: 0;
    display: flex;
    justify-content: center;
    margin-top: 10px;
    width: 100%;
  }

  .social-media-list li {
    margin: 0 5px;
  }

  .footer-logo img {
    width: 50%;
    margin-top: 20px;
  }
  
}

@media (max-width: 375px) {
  /* Prezzi e titoli */
  .large-price {
    font-size: 1.8rem;
  }

  .large-price.smaller {
    font-size: 1.2rem;
  }

  .small-title {
    font-size: 1rem !important;
  }
  
  .bolletta-testi {
    font-size: 1.1rem !important;
    margin: 10px 0;
  }
  
  .comprehension-title {
    font-size: 1.4rem !important;
    width: 100%;
    box-sizing: border-box;
  }

  /* Bottoni */
  .offer-cta {
    padding: 10px;
    font-size: 0.8rem;
  }

  /* Titoli */
  .carousel-title {
    margin-top: 70px;
    font-size: 2.2rem
  }
  
  /* Immagini più compatte */
  .responsive-image {
    max-height: 200px;
  }
}
</style>